import { initLogger } from "@swa-ui/dotcom";

initLogger("dotcom-landing-page");
